// Utility functions for checking step completion based on entry data

const TOTAL_STEPS = 6;

export const isStepCompleted = (entryData: any, stepIndex: number): boolean => {
    switch (stepIndex) {
        case 0:
            return entryData.at_sea !== undefined && entryData.at_sea !== null;
        case 1:
            return entryData.at_sea_all_day !== undefined && entryData.at_sea_all_day !== null;
        case 2: {
            if (entryData.at_sea_all_day === true) {
                return true;
            }
            return Array.isArray(entryData.at_sea_intervals) && entryData.at_sea_intervals.length > 0;
        }
        case 3: {
            if (entryData.at_sea === false) {
                return true;
            }
            return Array.isArray(entryData.on_duty_intervals) && entryData.on_duty_intervals.length > 0;
        }
        case 4:
            return entryData.glucose_issue !== undefined && entryData.glucose_issue !== null;
        case 5:
            return !!entryData.submitted_at;
        default:
            return false;
    }
};

export const getCompletedSteps = (entryData: any): number[] => {
    const steps = [];
    for (let i = 0; i < TOTAL_STEPS; i++) {
        if (isStepCompleted(entryData, i)) {
            steps.push(i);
        }
    }
    return steps;
};

export const isStepAccessible = (entryData: any, stepIndex: number): boolean => {
    switch (stepIndex) {
        case 0:
            return true; // Always accessible
        case 1:
            return entryData.at_sea === true;
        case 2:
            return entryData.at_sea === true && entryData.at_sea_all_day === false;
        case 3: {
            if (entryData.at_sea !== true) return false;
            if (entryData.at_sea_all_day === true) return true;
            return Array.isArray(entryData.at_sea_intervals) && entryData.at_sea_intervals.length > 0;
        }
        case 4:
            return true; // Always accessible after prior steps
        case 5:
            return true; // Final step
        default:
            return false;
    }
};

export const canNavigateToStep = (currentStep: number, targetStep: number, entryData: any): boolean => {
    // Can always go back to previous steps
    if (targetStep < currentStep) return true;

    // Can stay on current step
    if (targetStep === currentStep) return true;

    // Can go forward only if target step is accessible and all prior steps are completed
    return isStepAccessible(entryData, targetStep) && getCompletedSteps(entryData).includes(targetStep);
};
